import { history } from '../store/index';
import { store } from '../../NextApp';
import { generateQueryString } from "../../util/Api";

import {
  CREATE_FUEL_SENSOR_CALIBRATION_SUCCESS,
  GET_FUEL_SENSOR_CALIBRATION_SUCCESS,
} from "../../constants/ActionTypes";

import axios from 'util/Api'
import { fetchError, fetchFilter, fetchStart, fetchSubElementFilter, fetchSuccess } from "./Common";
import { getUser } from "./Auth";
import { message } from "antd";
import { arrayToCSV, downloadCSV } from "../../util/methods";


export const getResourceSuccess = ({ data }) => {
  return {
    type: GET_FUEL_SENSOR_CALIBRATION_SUCCESS,
    data,
  };
};

export const createResourceSuccess = ({ data }) => {
  return {
    type: CREATE_FUEL_SENSOR_CALIBRATION_SUCCESS,
    data
  };
};


export const getCalibrationList = (assetId, deviceId) => {
  return async (dispatch) => {
    // console.log(deviceId);
    dispatch(fetchStart());

    try {

      const response = await axios.get(`/asset-fuel-sensor-calibration/${assetId}/${deviceId}`);
      // console.log(response)
      dispatch(fetchSuccess());
      dispatch(getResourceSuccess({ data: response.data }));
    } catch (error) {
      // message.error(error.response.data.message);
      message.error("Record not found");
      // dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const createCalibrationList = (assetId, deviceId, payload) => {
  return async (dispatch) => {
    // console.log(payload, deviceId);
    dispatch(fetchStart());

    try {
      const response = await axios.post(`/asset-fuel-sensor-calibration/${assetId}/${deviceId}`, payload);
      if (response && response.data && response.data.code === 404) {
        message.error(response.data.message);
      } else {
        dispatch(fetchSuccess());
        dispatch(createResourceSuccess({ data: response.data }));
        message.success(`Calibration list saved successfully`);
      }
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const createFilteration = (assetId, deviceId, payload) => {
  return async (dispatch) => {
    console.log(payload, deviceId);
    dispatch(fetchStart());

    try {
      const response = await axios.post(`/asset-fuel-sensor-calibration/filteration/${assetId}/${deviceId}`, payload);
      if (response && response.data && response.data.code === 404) {
        message.error(response.data.message);
      } else {
        dispatch(fetchSuccess());
        dispatch(createResourceSuccess({ data: response.data }));
        message.success(`Filteration saved successfully`);
      }
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const deleteCalibrationList = (assetId, deviceId) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      await axios.delete(`/asset-fuel-sensor-calibration/${assetId}/${deviceId}`);
      message.success(`Calibration list deleted successfully`);
      dispatch(fetchSuccess());
      dispatch(getCalibrationList(assetId, deviceId));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};
